import Api from '../../api/Api'

const campaign = {
    namespaced: true,
    state: {
        campaigns: [],
        nextExists: false,
        nextPage: 0,
        campaign: {},
        user: {},
        // Hapus sumDonation: [], karena tidak digunakan
        donations: [],
        // Tambah state untuk total akumulasi
        total_akumulasi: 0
    },
    mutations: {
        SET_CAMPAIGNS(state, campaigns) {
            state.campaigns = campaigns
        },
        SET_NEXTEXISTS(state, nextExists) {
            state.nextExists = nextExists
        },
        SET_NEXTPAGE(state, nextPage) {
            state.nextPage = nextPage
        },
        SET_LOADMORE(state, data) {
            data.forEach(row => {
                state.campaigns.push(row);
            });
        },
        DETAIL_CAMPAIGN(state, data) {
            state.campaign = data
        },
        DETAIL_USER(state, data) {
            state.user = data
        },
        // Hapus DETAIL_SUMDONATION
        SET_DONATIONS(state, data) {
            state.donations = data
        },
        // Tambah mutation untuk total akumulasi
        SET_TOTAL_AKUMULASI(state, total) {
            state.total_akumulasi = total
        },
    },
    actions: {
        getCampaign({ commit }) {
            Api.get('/campaigns')
            .then(response => {
                commit('SET_CAMPAIGNS', response.data.data.data)
                if (response.data.data.current_page < response.data.data.last_page) {
                    commit('SET_NEXTEXISTS', true)
                    commit('SET_NEXTPAGE', response.data.data.current_page + 1)
                } else {
                    commit('SET_NEXTEXISTS', false)
                }
            }).catch(error => {
                console.log(error)
            })
        },
        getLoadMore({ commit }, nextPage) {
            Api.get(`/campaigns?page=${nextPage}`)
            .then(response => {
                commit('SET_LOADMORE', response.data.data.data)
                if (response.data.data.current_page < response.data.data.last_page) {
                    commit('SET_NEXTEXISTS', true)
                    commit('SET_NEXTPAGE', response.data.data.current_page + 1)
                } else {
                    commit('SET_NEXTEXISTS', false)
                }
            }).catch(error => {
                console.log(error)
            })
        },
        getDetailCampaign({ commit }, slug) {
            Api.get(`/campaigns/${slug}`)
            .then(response => {
                commit('DETAIL_CAMPAIGN', response.data.data)
                commit('DETAIL_USER', response.data.data.user)
                // Commit total_akumulasi dari response
                commit('SET_TOTAL_AKUMULASI', response.data.total_akumulasi)
                commit('SET_DONATIONS', response.data.donations)
            }).catch(error => {
                console.log(error)
            })
        },
        searchCampaign({ commit }, querySearch='') {
            const token = localStorage.getItem('token')
            Api.defaults.headers.common['Authorization'] = `Bearer ${token}`
            Api.get(`/campaigns?q=${querySearch}`)
            .then(response => {
                commit('SET_CAMPAIGNS', response.data.data.data)
            }).catch(error => {
                console.log(error)
            })
        },
    },
    getters: {}
}

export default campaign